import React from 'react';
import { SCREEN_EVENT_TYPE, UI_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
export default function useACTAnalyticsEvents() {
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const createInteractedUIEvent = React.useCallback(action => createAnalyticsEvent({
    eventType: UI_EVENT_TYPE,
    ...action
  }), [createAnalyticsEvent]);
  const createScreenUIEvent = React.useCallback(name => createAnalyticsEvent({
    eventType: SCREEN_EVENT_TYPE,
    name
  }), [createAnalyticsEvent]);
  return {
    createInteractedUIEvent,
    createScreenUIEvent
  };
}